import { Component } from '@angular/core';
import { SourceAppEnum } from '@app/modules/application/models/source-app.model';
import { ApplicationService } from '@app/modules/application/services/application.service';
import { MessageService } from '@app/shared/services/message.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public constructor(private messageService: MessageService, private appService: ApplicationService) {
    this.messageService.initMessageListener();
  }

  get sourceApp(): SourceAppEnum {
    return this.appService.app.sourceApp;
  }
}
